import React from 'react';
import './Legal.css';

const pages = {
  privacy: {
    eyebrow: 'Privacy',
    title: 'Privacy Policy',
    intro: 'How Dalytix handles personal data submitted through this website and related business conversations.',
    sections: [
      ['Information we collect', 'We collect the information you choose to submit through contact, consultation, newsletter, and career forms, including name, work email, company, role, phone number, inquiry details, and related messages.'],
      ['How we use it', 'We use this information to respond to inquiries, schedule consultations, manage recruiting conversations, send requested updates, improve the website, and maintain business records.'],
      ['Sharing and processors', 'We do not sell personal data. We may share information with trusted service providers that help operate hosting, analytics, email, CRM, security, and form processing services.'],
      ['Retention', 'We retain business inquiry records only as long as needed for the purpose collected, legal obligations, dispute resolution, and legitimate business administration.'],
      ['Your choices', 'You may request access, correction, deletion, or unsubscribe from marketing messages by contacting hello@dalytix.com.'],
    ],
  },
  terms: {
    eyebrow: 'Terms',
    title: 'Terms of Use',
    intro: 'The terms that govern use of the Dalytix website and public materials.',
    sections: [
      ['Website content', 'The website is provided for general information only. It does not create a consulting, legal, financial, or technical advisory relationship.'],
      ['No warranty', 'We work to keep content accurate and current, but the website is provided as-is without warranties of completeness, availability, or fitness for a specific purpose.'],
      ['Intellectual property', 'Dalytix names, marks, copy, visuals, and website materials are owned by Dalytix or used with permission and may not be reused without written consent.'],
      ['Third-party links', 'The website may link to third-party platforms. Dalytix is not responsible for their content, availability, or privacy practices.'],
      ['Contact', 'Questions about these terms can be sent to hello@dalytix.com.'],
    ],
  },
  cookies: {
    eyebrow: 'Cookies',
    title: 'Cookie Notice',
    intro: 'How this website may use cookies and similar technologies.',
    sections: [
      ['Essential cookies', 'Essential cookies may be used to keep the website secure, functional, and reliable.'],
      ['Analytics and performance', 'If analytics are enabled, they help us understand aggregate page usage, improve content, and identify technical issues.'],
      ['Marketing cookies', 'Marketing cookies are not required for core website use and should only be enabled where appropriate consent is collected.'],
      ['Managing cookies', 'You can manage cookies through your browser settings. Blocking some cookies may affect site functionality.'],
    ],
  },
  trust: {
    eyebrow: 'Trust',
    title: 'Trust & Security',
    intro: 'The principles Dalytix applies when designing, building, and operating AI and data systems.',
    sections: [
      ['Security by design', 'We design access control, least privilege, auditability, secrets handling, and operational controls into delivery plans from the start.'],
      ['Responsible AI', 'AI systems are designed with evaluation, grounding, human review paths, risk classification, and documented operating policies.'],
      ['Data governance', 'We prioritize lineage, ownership, contracts, quality checks, privacy controls, and clear handover documentation.'],
      ['Production readiness', 'Production work includes observability, runbooks, release gates, rollback paths, and operational accountability.'],
      ['Vendor-neutral architecture', 'We bias toward open standards, clean exits, and client ownership of long-term operating capability.'],
    ],
  },
  dpa: {
    eyebrow: 'DPA',
    title: 'Data Processing Addendum',
    intro: 'A high-level summary of data processing commitments for clients and prospects.',
    sections: [
      ['Processing scope', 'Dalytix processes personal data only for agreed business purposes, such as responding to inquiries, supporting delivery, or operating agreed services.'],
      ['Sub-processors', 'Where third-party processors are used, they are selected for appropriate security and operational controls.'],
      ['Client data', 'Client project data should be governed by a signed agreement, statement of work, and applicable security requirements before access is granted.'],
      ['Requests', 'DPA or security review requests can be sent to hello@dalytix.com.'],
    ],
  },
};

const LegalPage = ({ type }) => {
  const page = pages[type] || pages.privacy;

  return (
    <div className="legal-page page-shell">
      <section className="legal-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">{page.eyebrow}</span>
          <h1>{page.title}</h1>
          <p>{page.intro}</p>
        </div>
      </section>

      <section className="section">
        <div className="site-container legal-content">
          {page.sections.map(([title, text]) => (
            <section className="legal-section" key={title}>
              <h2>{title}</h2>
              <p>{text}</p>
            </section>
          ))}

          <div className="legal-contact-card professional-card">
            <h2>Contact Dalytix</h2>
            <p>For legal, privacy, security, or data processing questions, email <a className="learn-more" href="mailto:hello@dalytix.com">hello@dalytix.com</a>.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
